export class ImosPortFunctionMap {
    constructor(imosPortFunctionMapId: number, eventTypeGroupId: number, imosPortFunction: string) {
        this.imosPortFunctionMapId = imosPortFunctionMapId;
        this.eventTypeGroupId = eventTypeGroupId;
        this.imosPortFunction = imosPortFunction;
    }
    imosPortFunctionMapId: number;
    eventTypeGroupId: number;
    imosPortFunction: string;
}
